import { NumberFormatValues } from "react-number-format";

export const isAllowedReactNumberFormatValidInt = ({
  floatValue,
}: NumberFormatValues) => (floatValue ?? 0) < Number.MAX_SAFE_INTEGER;
